<div class="linked-fields tab-content">
  <mat-card class="linked-fields__existing__card">
    <mat-card-title>
      Existing Linked Fields
    </mat-card-title>
    @if (existingLinkedFieldSets == null || existingLinkedFieldSets?.length == 0) {
      <div class="linked-fields__existing__not-found">
        No existing linked field sets could be found
      </div>
    }
    @if (existingLinkedFieldSets != null && existingLinkedFieldSets?.length > 0) {
      <mat-card-content>
        @for (linkedFieldSet of existingLinkedFieldSets; track linkedFieldSet) {
          <mat-card class="linked-fields__existing ava-row">
            <div class="linked-fields__existing__parent ava-row__inline-block ava-box-item">
              {{ linkedFieldSet.ParentDisplayName }}
            </div>
            <div class="linked-fields__existing__linking-arrow ava-icon-item ava-row__inline-block">
              <span class="material-icons ava-icon__large">arrow_right_alt</span>
            </div>
            <div class="linked-fields__existing__child ava-row__inline-block ava-box-item">
              {{ linkedFieldSet.ChildDisplayName }}
            </div>
            @if (!addNewFieldToggle) {
              <button mat-icon-button class="ava-icon__delete"
                (click)="onDeleteExistingFieldSetButtonClick(linkedFieldSet.LinkedFieldSetId)"
                id="linked-field-delete-{{linkedFieldSet.LinkedFieldSetId}}">
                <mat-icon>delete</mat-icon>
              </button>
            }
          </mat-card>
        }
      </mat-card-content>
    }
  </mat-card>
  @if (addNewFieldToggle) {
    <mat-card class="linked-fields__new__card">
      <mat-card-title>
        New Linked Field Set
      </mat-card-title>
      <mat-card-content>
        <mat-card class="linked-fields__new ava-row">
          <mat-form-field class="linked-fields__new__parent ava-row__inline-block">
            @if (selectedNewParentField.StepId) {
              <mat-label>{{selectedNewParentField.StepId}}: {{selectedNewParentField.ParentPropertyName}}</mat-label>
            }
            <mat-select (selectionChange)="onParentFieldChange($event)" id="linked-field-parent-dropdown">
              @for (parentField of availableParentFields; track parentField) {
                <mat-option [value]="parentField" id="linked-field-parent-dropdown-{{parentField.ParentPropertyName}}">
                  {{parentField.DisplayName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class="linked-fields__new__linking-arrow ava-icon-item ava-row__inline-block">
            <span class="material-icons ava-icon__large">arrow_right_alt</span>
          </div>
          <mat-form-field class="linked-fields__new__child ava-row__inline-block">
            @if (selectedNewChildField.StepId) {
              <mat-label>{{selectedNewChildField.StepId}}: {{selectedNewChildField.ParentPropertyName}}</mat-label>
            }
            <mat-select (selectionChange)="onChildFieldChange($event)" id="linked-field-child-dropdown">
              @for (childField of availableChildFields; track childField) {
                @if (shouldShowChildFieldInDropDownList(childField)) {
                  <mat-option [value]="childField" id="linked-field-child-dropdown-{{childField.ParentPropertyName}}">
                    {{childField.DisplayName}}
                  </mat-option>
                }
              }
            </mat-select>
          </mat-form-field>
          <div class="linked-fields__new__save ava-icon-item ava-row__inline-block">
            <button class="material-icons ava-icon__medium ava-icon__button" (click)="onSaveNewFieldSetButtonClick()" [disabled]="isSaving" id="linked-field-save">
              save_alt
            </button>
            <button class="material-icons ava-icon__medium ava-icon__button" (click)="onCancelNewFieldSetButtonClick()" [disabled]="isSaving" id="linked-field-cancel">
              cancel
            </button>
          </div>
          <br />
          @if (showSaveErrorMessage) {
            <div class="clear linked-fields__new__save-error">
              <p>The linked field set you are trying to create is invalid</p>
              <p>Please ensure you have selected the correct fields</p>
            </div>
          }
        </mat-card>
      </mat-card-content>
    </mat-card>
  }
  <div class="linked-fields__new-linked-field">
    @if (!addNewFieldToggle) {
      <button mat-raised-button color="accent" (click)="onAddNewButtonClick()" id="linked-field-add-new">
        Add New
      </button>
    }
  </div>
</div>